module.exports = __webpack_public_path__ + "img/main-image.f9ae6fd0.png";